var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video',{directives:[{name:"in-viewport",rawName:"v-in-viewport",value:(_setup.showVideo),expression:"showVideo"}],ref:"backgroundVideo",attrs:{"poster":_vm.poster,"src":_vm.videoUrl,"playsinline":"","muted":""},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }